export default "__VITE_PUBLIC_ASSET__c9dd9214__"